import { PrinterFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { PrimaryColor } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconPrinterFilled: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <PrinterFilled {...props} style={{ ...props.style, color: PrimaryColor }} />;
};
